<mat-card class="card">
  <div style="text-align: center;">
    <p *ngIf="success" class="success">{{'REG_P5' | translate}}</p>
    <p *ngIf="!success" class="success">{{errorMessage}}</p>
  </div>
</mat-card>